/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { ModelViewerElement } from '@google/model-viewer';

import { htmlspecialchars } from './base.js';


export {
	ModelViewerElement
};


export function setupModelViewer( $wrapperElement, modelDataURL, posterSrc ) {

	ModelViewerElement.meshoptDecoderLocation = 'https://unpkg.com/meshoptimizer/meshopt_decoder.js';

	const html = '<model-viewer class="md-model lg-model"'
					+ ' shadow-intensity="1" camera-controls'
					+ ' src="'+htmlspecialchars(modelDataURL,true,true)+'"'
					+ ' autoplay ar ar-modes="webxr scene-viewer quick-look"'
					+ ' poster="'+htmlspecialchars(posterSrc,true,true)+'">'
					+'<div slot="progress-bar" class="default-progress-bar" aria-hidden="true">'
					+   '<div class="bar" part="default-progress-bar"></div>'
					+'</div>'
				+ '</model-viewer>';
	$wrapperElement.html(html);

	let $modelViewer = $wrapperElement.children('.md-model');
	let modelViewer = $modelViewer[0];

	let barElement = null;
	let parentNode = null;
	modelViewer.addEventListener( 'progress', ( event ) => {
		const progress = event.detail.totalProgress;
		// console.log(progress);
		if( barElement==null ) {
			barElement = modelViewer.querySelector('.default-progress-bar > .bar');
			barElement.classList.remove('hide');
			parentNode = barElement.parentNode;
			parentNode.classList.remove('hide');
		}
		requestAnimationFrame( () => {
			barElement.style.width = `${(100.0*progress).toFixed(2)}%`;
			if( progress===1.0 ) {
				barElement.classList.add('hide');
				parentNode.classList.add('hide');
				barElement = parentNode = null;
			}
		} );
	} );

	modelViewer.addEventListener( 'load', ( event ) => {
		// console.log({w:'load',event});
		if( barElement ) barElement.classList.add('hide');
		if( parentNode ) parentNode.classList.add('hide');
		barElement = parentNode = null;
		// eventually increase max-field-of-view (zoom-out range)
		if( modelViewer.getMaximumFieldOfView() < 90 ) {
			modelViewer.maxFieldOfView = '90deg';
		}
	} );

	modelViewer.addEventListener('render-scale', function( event ) {
		// reportedDpr.textContent = event.detail.reportedDpr;
		// renderedDpr.textContent = event.detail.renderedDpr;
		// minimumDpr.textContent = event.detail.minimumDpr;
		// pixelWidth.textContent = event.detail.pixelWidth;
		// pixelHeight.textContent = event.detail.pixelHeight;
		// reason.textContent = event.detail.reason;
		// invalidateCreatedPosterUrl();
	});
	// modelViewer.addEventListener('ar-status', function () {
		// // invalidateCreatedPosterUrl();
	// });
	modelViewer.addEventListener('camera-change', function( event ) {
		// invalidateCreatedPosterUrl();
	});

}
